import { render, staticRenderFns } from "./MatchesToPreferences.vue?vue&type=template&id=0fcf4cf2&scoped=true"
import script from "./MatchesToPreferences.vue?vue&type=script&lang=js"
export * from "./MatchesToPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf4cf2",
  null
  
)

export default component.exports